import OfferButtonsCell from './offer_buttons_cell';

export default OfferButtonsCell;
